export default __webpack_public_path__ + "static/media/new-prediction-screenshot.be637da6.jpg";